<template>
  <div class="uploader-file-container" :status="status">
    <div class="uploader-file" :status="status">
      <slot
        :file="file"
        :list="list"
        :status="status"
        :paused="paused"
        :error="error"
        :average-speed="averageSpeed"
        :formated-average-speed="formatedAverageSpeed"
        :current-speed="currentSpeed"
        :is-complete="isComplete"
        :is-uploading="isUploading"
        :size="size"
        :formated-size="formatedSize"
        :uploaded-size="uploadedSize"
        :progress="progress"
        :progress-style="progressStyle"
        :progressing-class="progressingClass"
        :time-remaining="timeRemaining"
        :formated-time-remaining="formatedTimeRemaining"
        :type="type"
        :extension="extension"
        :file-category="fileCategory"
        >
        <div class="uploader-file-info">
          <div class="uploader-file-name"><svg class="uploader-file-icon" aria-hidden="true"><use :xlink:href="fileCategory"></use></svg>{{file.name}}</div>
          <div class="uploader-file-size">{{formatedSize}}</div>
          <div class="uploader-file-status">
            <span v-show="status !== 'uploading'">{{statusText}}</span>
            <span v-show="status === 'uploading'">
              <em>{{formatedAverageSpeed}}</em>
              <i>{{formatedTimeRemaining}}</i>
            </span>
          </div>
        </div>
      </slot>
    </div>
    <el-progress class="uploader-progress" :status="progressStatus" :percentage="progressPrecent"></el-progress>
    <div class="uploader-file-actions">
      <span class="uploader-file-pause uploader-file-action" @click="pause">暂停</span>
      <span class="uploader-file-resume uploader-file-action" @click="resume">恢复</span>
      <span class="uploader-file-retry uploader-file-action" @click="retry">重传</span>
      <span class="uploader-file-remove uploader-file-action" @click="remove">{{status === 'success' || progressStatus === 'success' ? '删除' : '取消'}}</span>
    </div>
  </div>
</template>

<script>
  import Uploader from 'simple-uploader.js'
  import events from '../common/file-events'
  import { secondsToStr, type2Icon, formatSize } from '../common/utils'
  if (typeof window !== 'undefined') {
    require('../iconfont/iconfont.js')
  }
  const COMPONENT_NAME = 'uploader-file'
  export default {
    name: COMPONENT_NAME,
    props: {
      file: {
        type: Object,
        default () {
          return {}
        }
      },
      list: {
        type: Boolean,
        default: false
      }
    },
    inject: ['uploader'],
    data () {
      return {
        paused: false,
        error: false,
        averageSpeed: 0,
        currentSpeed: 0,
        isComplete: false,
        isUploading: false,
        size: 0,
        formatedSize: '',
        uploadedSize: 0,
        progress: 0,
        timeRemaining: 0,
        type: '',
        extension: '',
        progressingClass: ''
      }
    },
    computed: {
      isVirtualFile () {
        return this.file.uploader === false
      },
      fileCategory () {
        const extension = this.extension
        const isFolder = this.file.isFolder
        return type2Icon(extension, isFolder)
      },
      progressPrecent () {
        let progress = Math.floor(this.progress * 100)
        if (progress >= 100 && this.progressStatus !== 'success') return 99
        return progress
      },
      progressStatus () {
        // const isUploading = this.isUploading || this.file.uploading
        const isComplete = this.isComplete || this.file.complete
        const isError = this.error || this.file.error
        // const paused = this.paused || this.file.pased
        if (isComplete) {
          return 'success'
        } else if (isError) {
          return 'exception'
        } else {
          return 'text'
        }
      },
      progressStyle () {
        const progress = Math.floor(this.progress * 100)
        const style = `translateX(${Math.floor(progress - 100)}%)`
        return {
          progress: `${progress}%`,
          webkitTransform: style,
          mozTransform: style,
          msTransform: style,
          transform: style
        }
      },
      formatedAverageSpeed () {
        if (this.isVirtualFile) return
        return `${Uploader.utils.formatSize(this.averageSpeed)} / s`
      },
      status () {
        const isUploading = this.isUploading
        const isComplete = this.isComplete
        const isError = this.error
        const paused = this.paused
        if (this.isVirtualFile) return 'v'
        if (isComplete) {
          return 'success'
        } else if (isError) {
          return 'error'
        } else if (isUploading) {
          return 'uploading'
        } else if (paused) {
          return 'paused'
        } else {
          return 'waiting'
        }
      },
      statusText () {
        const status = this.status
        if (this.file.uploader) return this.file.uploader.fileStatusText[status] || status
        else return '成功了'
      },
      formatedTimeRemaining () {
        if (this.isVirtualFile) return
        const timeRemaining = this.timeRemaining
        const file = this.file
        if (timeRemaining === Number.POSITIVE_INFINITY || timeRemaining === 0) {
          return ''
        }
        let parsedTimeRemaining = secondsToStr(timeRemaining)
        const parseTimeRemaining = file.uploader.opts.parseTimeRemaining
        if (parseTimeRemaining) {
          parsedTimeRemaining = parseTimeRemaining(timeRemaining, parsedTimeRemaining)
        }
        return parsedTimeRemaining
      }
    },
    watch: {
      status (newStatus, oldStatus) {
        if (oldStatus && newStatus === 'uploading' && oldStatus !== 'uploading') {
          this.tid = setTimeout(() => {
            this.progressingClass = 'uploader-file-progressing'
          }, 200)
        } else {
          clearTimeout(this.tid)
          this.progressingClass = ''
        }
      }
    },
    methods: {
      _actionCheck () {
        this.paused = this.file.paused
        this.error = this.file.error
        if (this.file.isUploading) this.isUploading = this.file.isUploading()
        else this.isUploading = this.file.uploading
      },
      pause () {
        if (this.isVirtualFile) return
        this.file.pause()
        this._actionCheck()
        this._fileProgress()
      },
      resume () {
        if (this.isVirtualFile) return
        this.file.resume()
        this._actionCheck()
      },
      remove () {
        if (this.isVirtualFile) {
          // 虚拟文件删除事件
          if (this.uploader.emitter) {
            this.uploader.emitter.emit('removeFile', this.file)
          }
          return
        }
        this.file.cancel()
      },
      retry () {
        if (this.isVirtualFile) return
        this.file.retry()
        this._actionCheck()
      },
      fileEventsHandler (event, args) {
        if (this.isVirtualFile) return
        const rootFile = args[0]
        const file = args[1]
        const target = this.list ? rootFile : file
        if (this.file === target) {
          if (this.list && event === 'fileSuccess') {
            return
          }
          this[`_${event}`].apply(this, args)
        }
      },
      _fileProgress () {
        this.progress = this.file.progress()
        this.averageSpeed = this.file.averageSpeed
        this.currentSpeed = this.file.currentSpeed
        if (this.file.timeRemaining) this.timeRemaining = this.file.timeRemaining()
        if (this.file.sizeUploaded) this.uploadedSize = this.file.sizeUploaded()
        this._actionCheck()
        if (!this.file.uploader) this._fileSuccess()
      },
      _fileSuccess () {
        this._fileProgress()
        this.error = false
        this.isComplete = true
        this.isUploading = false
      },
      _fileComplete () {
        this._fileSuccess()
      },
      _fileError () {
        this._fileProgress()
        this.error = true
        this.isComplete = false
        this.isUploading = false
      }
    },
    mounted () {
      if (this.file.uploader) {
        const staticProps = ['paused', 'error', 'averageSpeed', 'currentSpeed']
        const fnProps = [
          'isComplete',
          'isUploading',
          {
            key: 'size',
            fn: 'getSize'
          },
          {
            key: 'formatedSize',
            fn: 'getFormatSize'
          },
          {
            key: 'uploadedSize',
            fn: 'sizeUploaded'
          },
          'progress',
          'timeRemaining',
          {
            key: 'type',
            fn: 'getType'
          },
          {
            key: 'extension',
            fn: 'getExtension'
          }
        ]
        staticProps.forEach(prop => {
          this[prop] = this.file[prop]
        })
        fnProps.forEach((fnProp) => {
          if (typeof fnProp === 'string') {
            this[fnProp] = this.file[fnProp]()
          } else {
            this[fnProp.key] = this.file[fnProp.fn]()
          }
        })

        const handlers = this._handlers = {}
        const eventHandler = (event) => {
          handlers[event] = (...args) => {
            this.fileEventsHandler(event, args)
          }
          return handlers[event]
        }
        events.forEach((event) => {
          this.file.uploader.on(event, eventHandler(event))
        })
      } else {
        this.extension = this.file.extension
        this.progress = this.file.progress()
        this.formatedSize = formatSize(this.file.size)
      }
    },
    destroyed () {
      if (this.file.uploader) {
        events.forEach((event) => {
          this.file.uploader.off(event, this._handlers[event])
        })
        this._handlers = null
      }
    }
  }
</script>

<style lang="scss">
  .uploader-file-container {
    position: relative;
  }
  .uploader-file {
    position: relative;
    height: 49px;
    line-height: 49px;
    overflow: hidden;
  }
  // 虚拟文件 允许删除
  .uploader-file-container[status="v"] .uploader-file-remove {
    display: block;
  }
  .uploader-file-container[status="waiting"] .uploader-file-pause,
  .uploader-file-container[status="uploading"] .uploader-file-pause {
    display: block;
  }
  .uploader-file-container[status="uploading"] .uploader-file-remove {
    display: block;
  }
  .uploader-file-container[status="paused"] .uploader-file-resume {
    display: block;
  }
  .uploader-file-container[status="error"] .uploader-file-retry {
    display: block;
  }
  .uploader-file-container[status="success"] .uploader-file-remove {
    display: block;
  }
  .uploader-file-container[status="error"] .uploader-file-progress {
    background: #ffe0e0;
  }
  .uploader-progress {
    width: 88%
  }
  .uploader-file-progressing {
    transition: all .4s linear;
  }
  .uploader-file-info {
    position: relative;
    z-index: 1;
    height: 100%;
    overflow: hidden;
  }
  .uploader-file-info i,
  .uploader-file-info em {
    font-style: normal;
  }
  .uploader-file-name,
  .uploader-file-size,
  .uploader-file-meta,
  .uploader-file-status {
    float: left;
    position: relative;
    height: 100%;
  }
  .uploader-file-actions {
    position: absolute;
    right: 0;
    bottom: 0px;
    width: 12%;
    line-height: 1;
    .uploader-file-action {
      display: none;
      float: left;
      margin-right: 10px;
      cursor: pointer;
      &:hover {
        color: #409eef;
      }
      &.uploader-file-remove{ // 始终保持删除
        display: block!important;
      }
    }
  }
  .uploader-file-name {
    width: 45%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-indent: 14px;
  }
  .uploader-file-icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: top;
    margin-top: 13px;
    margin-right: 8px;
  }
  .uploader-file-size {
    width: 13%;
    text-indent: 10px;
  }
  .uploader-file-meta {
    width: 8%;
  }
  .uploader-file-status {
    width: 24%;
    text-indent: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/uploader/components/file.vue